import axios from 'axios'
import { bartenderPrinterData } from '@/comp/lib/printData'

const serialConnections = {}
const pluginConnections = {}

export default class EmisClient {
    constructor (domain = '127.0.0.1:32001') {
        this.domain = domain
        this.requests = axios.create(
            {
                baseURL: 'http://' + this.domain,
                timeout: 200000,
                withCredentials: false
            }
        )
    }

    async isActivate () {
        return new Promise(resolve => {
            this.requests.get('/app/getAppInfo')
                .then(() => resolve(true))
                .catch(() => resolve(false))
        })
    }

    async getApp () {
        return new Promise(resolve => {
            this.requests.get('/app/getAppInfo')
                .then(res => resolve(res.data.data))
                .catch(() => resolve({}))
        })
    }

    async getSerialPorts () {
        return new Promise(resolve => {
            this.requests.get('/serial/getPorts')
                .then(res => resolve(res.data.data))
                .catch(() => resolve([]))
        })
    }

    async getPrinters () {
        return new Promise(resolve => {
            this.requests.get('/bartender/getPrinters')
                .then(res => resolve(res.data.data))
                .catch(() => resolve({
                    printers: [],
                    defaultPrinter: ''
                }))
        })
    }

    async getLabelDataDict (labelPath, update = false) {
        return new Promise(resolve => {
            const params = { path: labelPath, update }
            this.requests.get('/bartender/getLabelDataDict', { params })
                .then(res => resolve(res.data.data))
                .catch(() => resolve({}))
        })
    }

    /**
     * 打印
     *
     * options 参数：
     *
     * isAsync - 异步打印，不会阻塞代码，默认 false
     * refresh - 客户端会缓存一定时间的标签 Task，如果本地标签变化不会马上刷新，传入 true 强制刷新
     *
     * @param printInfo
     * @param options
     * @returns {*}
     */
    async print (printInfo, options) {
        const data = bartenderPrinterData(printInfo['generalData'], printInfo['printFieldMappers'])
        console.log(data)
        const params = {
            ...{
                labelPath: printInfo.labelPath,
                labelCategory: printInfo.labelCategory,
                qty: 1,
                isAsync: false,
                refresh: false,
                printerName: '',
                printType: 'General',
                generalData: data,
                serializeData: {
                    serialQty: 0
                }
            },
            ...options
        }

        if (params.labelPath === '') {
            return
        }

        return new Promise(resolve => {
            const r = this.requests.post('/printer/printLabel', JSON.stringify(params), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            r.then(res => resolve(res.data.data)).catch(() => resolve(null))
        })
    }

    async printSn (printInfo, options) {
        const params = {
            ...{
                labelPath: printInfo.labelPath,
                labelCategory: printInfo.labelCategory,
                qty: printInfo['qty'],
                isAsync: false,
                refresh: false,
                printerName: '',
                printType: printInfo['printType'],
                generalData: printInfo['generalData'],
                serializeData: printInfo['serializeData']
            },
            ...options
        }

        if (params.labelPath === '') {
            return
        }

        return new Promise(resolve => {
            const r = this.requests.post('/printer/printLabel', JSON.stringify(params), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            r.then(res => resolve(res.data.data)).catch(() => resolve(null))
        })
    }

    connectPort (portId, options) {
        const { onmessage, onopen, reset } = options

        if (reset) {
            EmisClient.closeAllPorts()
        }
        EmisClient.closePort(portId)

        const url = `ws://${this.domain}/connectSerial/${portId}`
        const client = new WebSocket(url)

        client.onopen = evt => {
            serialConnections[portId] = client
            onopen && onopen(client, evt)
        }
        client.onclose = evt => {
            if (evt.code !== 3001) {
                setTimeout(() => this.connectPort(portId, options), 3000)
            }
        }
        client.onerror = evt => {
            console.warn('websocket closed.', evt)
        }
        client.onmessage = evt => {
            onmessage && onmessage(evt.data, evt)
        }
    }

    connectPlugin (pluginId, options) {
        const { onmessage, onopen, reset } = options
        if (reset) {
            EmisClient.closeAllPlugins()
        }
        EmisClient.closePlugin(pluginId)

        const url = `ws://${this.domain}/channel/${pluginId}`
        const client = new WebSocket(url)

        client.onopen = evt => {
            pluginConnections[pluginId] = client
            onopen && onopen(client, evt)
        }
        client.onclose = evt => {
            if (evt.code !== 3001) {
                setTimeout(() => this.connectPlugin(pluginId, options), 3000)
            }
        }
        client.onerror = evt => {
            console.warn('websocket closed.', evt)
        }
        client.onmessage = evt => {
            onmessage && onmessage(evt.data, evt)
        }
    }

    static closePlugin (pluginId) {
        if (pluginId in pluginConnections) {
            pluginConnections[pluginId].close(3001)
        }
    }

    static closeAllPlugins () {
        for (const p in pluginConnections) {
            pluginConnections[p].close(3001)
        }
    }

    static closePort (portId) {
        if (portId in serialConnections) {
            serialConnections[portId].close(3001)
        }
    }

    static closeAllPorts () {
        for (const p in serialConnections) {
            serialConnections[p].close(3001)
        }
    }
}



// WEBPACK FOOTER //
// ./src/comp/lib/emisClient.js